import type { ContractSchema } from '@libs/data-access/entities'
import { AvatarLabel } from '@libs/ui/ds'
import { membershipsSelectors } from '@spa/scenes/Plannings/redux/selectors'

type Props = {
  contract: ContractSchema
}

const BirthdayMember = ({ contract }: Props) => {
  const { membership_id } = contract
  const membership = membershipsSelectors.useGetCachedById(membership_id)

  return (
    <AvatarLabel
      size='m'
      src={membership?.avatar_urls?.thumb}
      labels={[membership?.firstname, membership?.lastname]}
    />
  )
}

export default BirthdayMember
